import { Locale } from '@/utility/locale';

export class AppError extends Error {
  statusCode: number;
  responseData?: unknown;
  constructor(message: string, statusCode: number, responseData?: unknown) {
    super(message);
    this.statusCode = statusCode;
    this.responseData = responseData;
    Error.captureStackTrace(this, this.constructor);
  }
}

export class SearchTermRedirectError extends Error {
  /** The search term that triggered the redirect (blocked or greylist rewrite). */
  originalSearchTerm: string;
  /**
   * When set, redirect to a PLP for this search term (greylist rewrite).
   * Always lowercased so we never emit mixed-case `/s/...` PLP URLs.
   * When unset, the term was blocklisted — redirect to the bestsellers PLP
   * and pass `originalSearchTerm` as a `redirectTerm` query param for analytics.
   */
  redirectSearchTerm: string | undefined;
  constructor(originalSearchTerm: string, redirectSearchTerm?: string) {
    super(
      redirectSearchTerm
        ? `Search term "${originalSearchTerm}" triggered a redirect to "${redirectSearchTerm}"`
        : `Search term "${originalSearchTerm}" was blocked`
    );
    this.originalSearchTerm = originalSearchTerm;
    this.redirectSearchTerm = redirectSearchTerm?.toLowerCase();
    Error.captureStackTrace(this, this.constructor);
  }
}

export class InvalidSearchFilterError extends Error {
  shopId: string | string[];
  locale: Locale;
  filter?: unknown;
  constructor(message: string, shopId: string | string[], locale: Locale, filter?: unknown) {
    super(message);
    this.shopId = shopId;
    this.locale = locale;
    this.filter = filter;
    Error.captureStackTrace(this, this.constructor);
  }
}
